import { PORTAL_HOME_ROUTE } from "@/lib/portal/portal-routes";
import { withBasePath } from "@/lib/portal/base-path";

/**
 * Canonical Request access route: Markdoc guide when Slice 6 is on,
 * legacy form when the flag is off.
 */
export const GLOFOX_REQUEST_ACCESS_ROUTE = "/glofox/request-access";

/**
 * Former in-app form URL. Kept only so saved links redirect to the
 * canonical route.
 */
export const GLOFOX_LEGACY_ACCESS_REQUEST_ROUTE = "/glofox/access-request";

/** Static Redoc artifact used by the main-compatible experience. */
export const GLOFOX_LEGACY_API_REFERENCE_HREF =
  "/glofox/api/openapi-reference.html";
/** @deprecated Legacy name retained for the main-compatible search index. */
export const GLOFOX_API_REFERENCE_HREF = GLOFOX_LEGACY_API_REFERENCE_HREF;

export function getGlofoxLegacyApiReferenceHref(): string {
  return withBasePath(GLOFOX_LEGACY_API_REFERENCE_HREF);
}
/** @deprecated Use only inside the main-compatible legacy experience. */
export const getGlofoxApiReferenceHref = getGlofoxLegacyApiReferenceHref;

const GLOFOX_AUTH_ROUTES = [PORTAL_HOME_ROUTE, "/login"] as const;

export function resolveGlofoxTopNavActive(pathname: string | null): {
  docs: boolean;
  apiReference: boolean;
  requestAccess: boolean;
} {
  if (!pathname) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (GLOFOX_AUTH_ROUTES.includes(pathname as (typeof GLOFOX_AUTH_ROUTES)[number])) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (
    pathname === "/glofox/api-reference" ||
    pathname === GLOFOX_LEGACY_API_REFERENCE_HREF
  ) {
    return { docs: false, apiReference: true, requestAccess: false };
  }

  if (
    pathname === GLOFOX_REQUEST_ACCESS_ROUTE ||
    pathname === GLOFOX_LEGACY_ACCESS_REQUEST_ROUTE
  ) {
    return { docs: false, apiReference: false, requestAccess: true };
  }

  if (pathname.startsWith("/glofox")) {
    return { docs: true, apiReference: false, requestAccess: false };
  }

  return { docs: false, apiReference: false, requestAccess: false };
}
